import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { PlaidConnection } from "@common/types/plaidConnection";
import { isFixablePlaidConnectionError } from "@common/helpers/financialConnection";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { DisconnectedConnectionMessage } from "@components/financialConnection/DisconnectedConnectionMessage";
import { AlertIcon } from "@icons";
import {
    ConnectionButtonSize,
    ConnectionButtonVariant,
} from "@components/financialConnection/ConnectionActionButton";
import { FixConnectionButton } from "@components/financialConnection/FixConnectionButton";
import { UnsupportedPlaidConnection } from "./UnsupportedPlaidConnection";

interface Props {
    connection: PlaidConnection;
    churnedAccount?: IntegrationAccount;
    triggerContent?: React.ReactNode;
    triggerVariant?: ConnectionButtonVariant;
    triggerClassName?: string;
    triggerSize?: ConnectionButtonSize;
    triggerLeftIcon?: React.ReactNode;
    triggerTooltip?: React.ReactNode;
    onFixed?: () => void;
}

export const BrokenPlaidConnectionLink: React.FC<Props> = ({
    connection,
    churnedAccount,
    triggerContent = "Fix connection",
    triggerVariant = "link",
    triggerClassName = "broken-connection-link danger",
    triggerSize = "sm",
    triggerLeftIcon = <AlertIcon className="icon-color-red-500" />,
    triggerTooltip,
    onFixed,
}) => {
    if (!isFixablePlaidConnectionError(connection.error)) {
        return <UnsupportedPlaidConnection error={connection.error} />;
    }

    const fixTrigger = (
        <FixConnectionButton
            connection={connection}
            integrationAccount={churnedAccount}
            onFixed={onFixed}
            variant={triggerVariant}
            className={triggerClassName}
            size={triggerSize}
            leftIcon={triggerLeftIcon}
            tooltip={triggerTooltip}
        >
            {triggerContent}
        </FixConnectionButton>
    );

    if (triggerVariant === "menuItem") {
        return fixTrigger;
    }

    return (
        <Tooltip
            content={
                <>
                    <div className="mb-2">
                        <DisconnectedConnectionMessage
                            connection={connection}
                        />
                    </div>
                    Select to fix it.
                </>
            }
        >
            <span>{fixTrigger}</span>
        </Tooltip>
    );
};
